import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

interface OrgBrandMarkProps {
	/** The organization's uploaded mark, or null to show `fallback` instead. */
	mark: string | null
	/** Rendered inside the frame when the organization has no mark of its own. */
	fallback?: ReactNode
	/** Frame size and radius for this surface, e.g. `size-20 rounded-xl`. */
	className?: string
	alt: string
	'data-testid': string
}

/**
 * An organization's brand mark in its standard frame.
 *
 * `object-cover` crops a non-square upload, which is what the upload guidelines in
 * `BrandingSection` promise. Changing that is a product decision, so it lives here once.
 */
export function OrgBrandMark({ mark, fallback, className, alt, 'data-testid': dataTestId }: OrgBrandMarkProps) {
	return (
		<div
			className={cn(
				'overflow-hidden border border-border shrink-0 flex items-center justify-center bg-muted',
				className,
			)}>
			{mark ? <img src={mark} className='size-full object-cover' alt={alt} data-testid={dataTestId} /> : fallback}
		</div>
	)
}
